import React from 'react';

const FinanceSectionHeader = ({
  sectionLabel = 'Administrativo',
  title,
  badgeLabel,
  ctaLabel,
  onCtaClick,
  showCtaDesktop = true,
}) => {
  return (
    <div className="grid gap-3 border-b border-[color:var(--cp-border,var(--border))] px-4 py-4 sm:px-5 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center">
      <div className="space-y-1">
        <p className="text-[11px] uppercase tracking-[0.24em] text-[color:var(--text-muted)]/90">{sectionLabel}</p>
        <div className="flex flex-wrap items-center gap-2">
          <h2 className="text-xl font-semibold tracking-tight text-[color:var(--text-primary)] sm:text-2xl">{title}</h2>
          {badgeLabel && (
            <span className="inline-flex items-center rounded-[var(--cp-radius-pill,999px)] border border-[color:var(--cp-border-strong,var(--border))] bg-[color:var(--cp-surface-soft,var(--surface-muted))] px-2.5 py-1 text-[11px] font-medium text-[color:var(--text-muted)]">
              {badgeLabel}
            </span>
          )}
        </div>
      </div>

      {showCtaDesktop && ctaLabel && onCtaClick && (
        <div className="flex items-center gap-2">
          <button
            onClick={onCtaClick}
            className="hidden sm:inline-flex items-center rounded-[0.7rem] border border-transparent bg-[color:var(--accent)] px-4 py-2 text-sm font-semibold text-white transition-all duration-[var(--cp-motion-base,220ms)] hover:-translate-y-0.5 hover:opacity-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--cp-surface,var(--surface))] motion-reduce:transform-none motion-reduce:transition-none"
          >
            {ctaLabel}
          </button>
        </div>
      )}
    </div>
  );
};

export default FinanceSectionHeader;
